import { Link } from 'react-router-dom'

import AuthHeader from '../features/auth/AuthHeader'

// Review #2, M3.6.1: reset used to drop the user straight back on /login with no
// confirmation that anything had happened. Styling follows ResetPassword — same header,
// same 576px column, same badge, same 264×56 action — so the two read as one flow.
const SuccessBadge = () => (
  <div className="relative w-[88px] h-[88px] rounded-full bg-[#e4f3da] flex items-center justify-center">
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12.5l4.5 4.5L19 7.5"
        stroke="#4CBC18"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span className="absolute -top-1 -left-1 text-brand-green text-[18px]">✦</span>
  </div>
)

const PasswordUpdated = () => (
  <div className="min-h-screen bg-brand-pageFill flex flex-col">
    <AuthHeader />

    {/* M3.3: 40px from the navbar to the content. */}
    <main className="flex-1 flex items-start justify-center px-6 pt-[40px]">
      <div className="w-full max-w-[576px] flex flex-col items-center gap-8">
        <SuccessBadge />

        <h1 className="text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] font-extrabold text-brand-dark text-center w-full">
          Password Updated
        </h1>

        <p className="text-[16px] text-brand-dark text-center">
          Your password has been changed. You can sign in with it now.
        </p>

        <Link
          to="/login"
          className="w-full max-w-[264px] h-[56px] rounded-full bg-brand-primary hover:bg-brand-hover text-white text-[16px] font-semibold flex items-center justify-center transition-colors"
        >
          Sign In
        </Link>

        {/* M3.6.2: no signup cross-link on the password-change pages. */}
      </div>
    </main>
  </div>
)

export default PasswordUpdated
